import {DragHandlerBase} from './drag-handler-base';
import {WallBoundsBoundingBoxFactory} from '../../../../custom/WallBoundsBoundingBox';
import {CollisionService} from '../../../../services/collision/collision.service';
import {Injectable} from '@angular/core';

class KeepObjectInWallBoundsHandler extends DragHandlerBase {

  private wallBoundsBoundingBox;

  constructor(
    nextHandler,
    private collisionSrvc: CollisionService,
    private wallBoundsBoundingBoxFactory: WallBoundsBoundingBoxFactory
  ) {
    super(nextHandler);
    this.wallBoundsBoundingBox = wallBoundsBoundingBoxFactory.create();
  }

  move(e, transformation) {
    const draggedObject = e.draggedObject,
      singleObjectDrag = e.draggedObjects.length === 1,
      collidedObject = this.collisionSrvc.isCollide(draggedObject, e.staticObjects, {
        newPosition: transformation.position
      });

    if (singleObjectDrag && !collidedObject) {

      const wall = draggedObject.parent,
        draggedObjectEntity = draggedObject.userData.entity;

      this.wallBoundsBoundingBox.calculateForObject(wall, draggedObjectEntity);

      this.wallBoundsBoundingBox.clampPoint(transformation.position, transformation.position);
    }

    super.move(e, transformation);
  }

}

@Injectable()
export class KeepObjectInWallBoundsHandlerFactory {

  constructor(
    private collisionService: CollisionService,
    private wallBoundsBoundingBoxFactory: WallBoundsBoundingBoxFactory
  ) {

  }

  create(nextHandler?: DragHandlerBase): DragHandlerBase {
    return new KeepObjectInWallBoundsHandler(
      nextHandler,
      this.collisionService,
      this.wallBoundsBoundingBoxFactory
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Handler/keep-object-in-wall-bounds-handler.ts